import React from 'react'
import {Button, Icon, Tooltip} from 'antd'
import {Link} from 'react-router-dom'

import {usersService} from 'services'
import FormHandler from 'components/Form/FormHandler'
import InputDecorated from 'components/Form/InputDecorated'
import FormContextProvider from 'components/Form/FormContextProvider'
import useUserContext from 'components/User/useUserContext'
import {logInUser} from 'utils/user'
import requestHandler from 'utils/requestHandler'

const AdditionalButton = <Link to='profile/change-password'><Button>Change password</Button></Link>

const UserForm = ({initialValue, history, existingUser}) => {
  const {user, setUser} = useUserContext()

  const submitCallback = (values, setLoading) => {
    requestHandler(() => usersService[existingUser ? 'usersEdit' : 'users'](values, user.uuid, user.accessToken), 'json')
      .then(response => {
        if (existingUser) {
          const newUser = JSON.parse(JSON.stringify(user))
          Object.keys(response.data).forEach(e => newUser[e] = response.data[e])
          setUser(newUser)
          history.push('/home')
        } else {
          logInUser(response, history, setUser, setLoading)
        }
        setLoading(false)
      })
  }

  return (
    <FormContextProvider>
      <FormHandler
        submitCallback={submitCallback}
        submitTitle={existingUser && 'Save'}
        AdditionalButtons={existingUser && AdditionalButton}
      >
        <InputDecorated fieldName='email' icon='mail' placeholder='Email (required)' initialValue={initialValue.email}
                        rules={[
                          {required: true, message: 'Please input your Email'},
                          {type: 'email', message: 'The input is not valid Email'},
                        ]} disabled={existingUser}/>
        {!existingUser && (
          <InputDecorated fieldName='password' icon='key' placeholder='Password (required)' password
                          rules={[{required: true, message: 'Please input your password'}]}/>
        )}
        <InputDecorated fieldName='name' icon='user' placeholder='Name' initialValue={initialValue.name}/>
        <InputDecorated fieldName='surname' icon='usergroup-add' placeholder='Surname'
                        initialValue={initialValue.surname}/>
        <InputDecorated fieldName='phone' icon='phone' placeholder='Phone' initialValue={initialValue.phone}/>
        <InputDecorated
          fieldName='token' icon='barcode' initialValue={initialValue.token}
          placeholder='Invite token' disabled={!!initialValue.token}
          suffix={
            <Tooltip title='Invite token, if you have any'>
              <Icon type='info-circle'/>
            </Tooltip>
          }
        />
      </FormHandler>
    </FormContextProvider>
  )
}

export default UserForm
